let originalTitle: string | null = null;
let flashInterval: ReturnType<typeof setInterval> | null = null;

export const setTabNotification = (message: string) => {
  clearTabNotification();
  originalTitle = document.title;
  let showMessage = true;

  flashInterval = setInterval(() => {
    document.title = showMessage ? `(!) ${message}` : (originalTitle || '');
    showMessage = !showMessage;
  }, 1500);
}

export const clearTabNotification = () => {
  if (flashInterval) {
    clearInterval(flashInterval);
    flashInterval = null;
  }
  if (originalTitle !== null) {
    document.title = originalTitle;
    originalTitle = null;
  }
}
